import {USA} from "../../constants";

const initialState = {
  step: 1,
  multiForm: {},
  form: {
    billing: {
      country: USA
    },
    addOns: {
      integrationDriver: false,
      dhis2SupportPlan: false
    }
  }
};

if (process.env.REACT_APP_USE_MOCKS === 'true') {
  const { onboardingFormMocks } = require("../../mocks");

  initialState.form = onboardingFormMocks;
}


export default initialState;
